<template>
  <div class="xscontainer jsjiesh">
    <div class="iiwerwer">
<!--      <el-tabs v-model="activeName" @tab-click="handleClick" >-->
<!--        <el-tab-pane label="我要参加认证" name="first">-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="证书查验" name="second">-->
<!--        </el-tab-pane>-->
<!--      </el-tabs>-->
      <el-radio-group v-model="activeName">
        <el-radio-button label="first">我要参加认证</el-radio-button>
        <el-radio-button label="second">证书查验</el-radio-button>
      </el-radio-group>
    </div>
    <div class="jdfgjsdgsd">
      <Woyaopeixun v-if="activeName == 'first'"></Woyaopeixun>
      <Zhengshuchaxun v-else></Zhengshuchaxun>
    </div>
  </div>
</template>

<script>
import Woyaopeixun from "@/components/lianmeng/Woyaopeixun";
import Zhengshuchaxun from "@/components/lianmeng/Zhengshuchaxun";
export default {
  components:{Woyaopeixun,Zhengshuchaxun},
  data() {
    return {
      activeName: 'second',
      fwcishu:0
    };
  },
  methods: {
    handleClick(tab, event) {

    }
  }
};
</script>

<style scoped>
.iiwerwer {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.jdfgjsdgsd{

  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
